import { render, staticRenderFns } from "./EllipsisTooltip.vue?vue&type=template&id=2be003c9&scoped=true&"
import script from "./EllipsisTooltip.vue?vue&type=script&lang=js&"
export * from "./EllipsisTooltip.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisTooltip.vue?vue&type=style&index=0&id=2be003c9&lang=scss&scoped=true&"
import style1 from "./EllipsisTooltip.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be003c9",
  null
  
)

export default component.exports